let SERVICE_REQUEST_CLEARED = 'CLEARED';
let SERVICE_REQUEST_NOT_CLEARED = 'NOT_CLEARED';

export { SERVICE_REQUEST_CLEARED, SERVICE_REQUEST_NOT_CLEARED };
